import React, { useMemo, lazy, memo } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useProjects } from '../hooks/useProjects';
const ProjectCard = memo(({
  project,
  index
}: {
  project: any;
  index: number;
}) => <motion.div initial={{
  opacity: 0
}} whileInView={{
  opacity: 1
}} viewport={{
  once: true,
  margin: '-50px'
}} transition={{
  duration: 0.4,
  delay: index * 0.1
}} className={`relative aspect-[4/3] overflow-hidden rounded-2xl sm:rounded-3xl bg-gray-200 shadow-md ${index > 0 ? 'hidden sm:block' : ''}`} data-id="element-450">
      <img src={project.images[0]} alt={project.name} className="h-full w-full object-cover" loading={index === 0 ? 'eager' : 'lazy'} decoding="async" data-id="element-451" />

      <div className="absolute inset-0 bg-gradient-to-t from-gray-900/90 via-gray-900/40 to-transparent" data-id="element-452" />

      <div className="absolute bottom-0 left-0 right-0 p-6" data-id="element-453">
        <span className="mb-2 inline-block rounded-full bg-blue-600 px-3 py-1 text-xs font-bold text-white shadow-lg" data-id="element-454">
          {project.category}
        </span>
        <p className="text-lg font-bold text-white mb-2" data-id="element-455">{project.name}</p>
        <div className="flex gap-3 text-white/90 text-sm" data-id="element-456">
          <span data-id="element-457">{project.year}</span>
          <span data-id="element-458">•</span>
          <span data-id="element-459">{project.m2.toLocaleString()} m²</span>
          <span data-id="element-460">•</span>
          <span data-id="element-461">{project.comuna}</span>
        </div>
      </div>
    </motion.div>);
ProjectCard.displayName = 'ProjectCard';
export const ProjectsGallery = memo(function ProjectsGallery() {
  const {
    projects: allProjects
  } = useProjects();
  const projectsToShow = useMemo(() => {
    const featuredProjects = allProjects.filter(p => p.featured).slice(0, 3);
    return featuredProjects.length > 0 ? featuredProjects : allProjects.slice(0, 3);
  }, [allProjects]);
  return <section className="bg-gray-50 py-16 sm:py-24 lg:py-32" data-id="element-462">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-463">
        <div className="mb-12 sm:mb-16 flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end" data-id="element-464">
          <div data-id="element-465">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-gray-900" data-id="element-466">
              Algunas de nuestras obras
            </h2>
            <p className="mt-3 sm:mt-4 text-lg sm:text-xl text-gray-500" data-id="element-467">
              Calidad, orden y detalle en cada ejecución.
            </p>
          </div>
          <Link to="/proyectos" className="rounded-full border border-gray-300 px-6 py-2 font-semibold text-gray-600 transition-colors hover:border-blue-600 hover:text-blue-600 text-sm sm:text-base" data-id="element-468">
            Ver otras obras terminadas
          </Link>
        </div>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-469">
          {projectsToShow.map((project, index) => <ProjectCard key={project.id} project={project} index={index} data-id="element-470" />)}
        </div>
      </div>
    </section>;
});